<template>
  <div>
    <el-card>
      <div class="header-menu">
        <el-form :inline="true" label-width="100px">
          <el-form-item label="任务名称">
            <el-input
              placeholder="请输入任务名称"
              clearable
              @clear="handleCilckClear"
              style="width: 250px;"
              v-model="inputTaskName">
               <!-- eslint-disable-next-line -->
              <el-button slot="append" icon="el-icon-search" @click="handleCilckSearch"></el-button>
          </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="addTask"
              class="btns"
              size="small"
              icon="el-icon-plus"
              >添加任务</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="taskDataList"
        :highlight-current-row="true"
        height="600"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}">
        <el-table-column prop="taskName" label="任务名称"></el-table-column>
        <el-table-column prop="taskUserName" label="创建人"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
           <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
           <span>{{scope.row.createTime.substring(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <el-button type="text" @click="editById(scope.$index, scope.row)"
              >编辑
            </el-button>
            <el-button type="text" @click="deleteById(scope.$index, scope.row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="display: flex; justify-content: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      :title="title"
      :visible="screenshotShow"
      width="55%"
      :close-on-click-modal = false
      :before-close="handlescreenshotCler"
    >
      <div style="display: flex; padding-left: 50px">
        <div
          style="
            line-height: 40px;
            margin-right: 10px;
            width: 80px;
            text-align: start;
          "
        >
          任务名称:
        </div>
        <div style="width: 90%">
          <el-input
            placeholder="请输入任务名称"
            clearable
            style="width: 100%"
            v-model="taskName"
          ></el-input>
        </div>
      </div>

      <div style="display: flex; padding-left: 50px; margin-top: 20px">
        <div
          style="
            line-height: 40px;
            margin-right: 10px;
            width: 80px;
            text-align: start;
          "
        >
          创建人:
        </div>
        <div style="width: 90%">
          <el-select
            filterable
            clearable
            v-model="taskCreator"
            placeholder="请选择创建人"
            style="width: 100%"
          >
            <el-option
              v-for="item in taskCreatorList"
              :key="item.id"
              :value="item.id"
              :label="item.realname"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="dialog-footer" style="margin-top: 100px">
        <el-button @click="handlescreenshotCler" style="margin-right: 50px"
          >取 消</el-button
        >
        <el-button type="primary" @click="handlescreenshotSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
    ApiTeacherAll,
    ApiAddTask,
    ApiDelet,
    ApiAddTaskList,
    ApiAddTaskUpdate,
} from '../../api/apiTask'


export default {
  name: "agencyTasks",
  data() {
    return {
      pages: 1,
      pageSize: 10,
      total: 0,
      screenshotShow: false,
      inputTaskName: "",
      taskName: "",
      taskCreator:"",
      taskCreatorList:[],
      taskDataList:[],
      title:"",
    };
  },

  created() {},
  mounted() {
    this.getApiTeacherAll()
    this.getApiAddTaskList()
  },
  methods: {
    addTask() {
      this.Id = ''
      this.title = "添加任务名称"
      this.screenshotShow = true;
    },
    handlescreenshotCler() {
      this.taskName = ""
      this.taskCreator = ""
      this.screenshotShow = false;
    },
    handlescreenshotSubmit() {
      if( this.taskName == "" || this.taskCreator == ""){
          this.$message({  message: "任务名称或创建人不能为空", type: "warning"})
      }else{
        if(this.Id == "" ){
          this.getApiAddTask()
        }else{
          this.getApiAddTaskUpdate()
        }
      }
    },
    deleteById(index, row) {
      this.$confirm("此操作将删除该该学生, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteStudentById(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    deleteStudentById(id) {
      ApiDelet(id)
        .then(() => {
          this.$message({ message: "删除成功", type: "success" });
          this.getApiAddTaskList()
        })
        .catch((error) => {
          this.$message.error("删除失败");
        });
    },

    editById(index, row) {
      this.title = "编辑待办任务名称"
      this.taskCreator = row.taskUser
      this.taskName = row.taskName
      this.Id = row.id
      this.screenshotShow = true;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.getApiAddTaskList()
    },
    handleCurrentChange(val) {
      this.pages = val;
      this.getApiAddTaskList()
    },

    getApiAddTask(){
      let data = { taskUser: this.taskCreator, taskName: this.taskName}
      ApiAddTask(data).then((res)=>{
         if(res.code == 200){
            this.handleSuccess(res)
         }else{
            this.$message.error(res.message);
         }
      })
    },

    getApiAddTaskUpdate(){
      let data = { taskUser: this.taskCreator, taskName: this.taskName , id: this.Id}
      ApiAddTaskUpdate(data).then((res)=>{
         if(res.code == 200){
            this.handleSuccess(res)
         }else{
            this.$message.error(res.message);
         }
      })
    },
    handleSuccess(res){
      this.getApiAddTaskList()
      this.$message({ message: res.message, type: "success" });
      this.taskName = ""
      this.taskCreator = ""
      this.screenshotShow = false;
    },
    getApiTeacherAll(){
      ApiTeacherAll().then((res)=>{
        let { data } = res
        this.taskCreatorList = data
      })
    },
    handleCilckSearch(){
      this.pages = 1
      this.getApiAddTaskList(this.inputTaskName)
    },
    handleCilckClear(){
      this.pages = 1
      this.getApiAddTaskList("")
    },
    getApiAddTaskList(TaskName){
      let data = { pages: this.pages, pageSize: this.pageSize, taskName:TaskName }
      ApiAddTaskList(data).then((res)=>{
        let { data } = res
        this.taskDataList = data.records
        this.total = data.total
        this.pageSize = data.size
        this.pages = data.current
      })
    },



  },
};
</script>

<style scoped >
.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb >>> .el-dialog {
    width: 70%;
  }

  .el-input-group {
    width: 60%;
  }

  .sex {
    margin-left: -15% !important;
  }
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}
.el-form-item__content {
  width: 80% !important;
}
</style>



// WEBPACK FOOTER //
// src/manager/assembly/taskNameManage.vue